import styled from 'styled-components';

import likeIcon from '~/assets/icon-like.png';
import cloud01 from '~/assets/cloud-01.png';
import cloud02 from '~/assets/cloud-02.png';

export const Container = styled.section`
  margin-bottom: 200px;
  margin-top: 100px;
  &:before,
  &:after {
    content: ' ';
    display: table;
  }
  &:after {
    clear: both;
  }
  & {
    *zoom: 1;
  }
  /* @media (max-width: 1200px) {
    overflow-x: hidden;
  } */
  position: relative;
  .ArrowDown {
    margin-bottom: -90px;
  }
`;
export const Title = styled.h3`
  width: 100%;
  max-width: 1710px;
  padding: 0 15px;
  color: #27357c;
  font-size: 50px;
  font-weight: 900;
  text-shadow: 2px 2px 0 #a8dff4;
  text-align: center;
  margin: 0 auto;
  span {
    color: #831d13;
  }
  @media (max-width: 992px) {
    font-size: calc(100vw / 15);
  }
  @media (max-width: 540px) {
    font-size: calc(100vw / 10);
  }
`;

export const Timeline = styled.ul`
  position: relative;
  margin-top: 60px;
  float: left;
  &:before {
    z-index: 1;
    content: '';
    position: absolute;
    width: 10px;
    height: 100%;
    height: 90%;
    background-color: #ee6255;
    border-radius: 50px;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
  }

  @media (max-width: 768px) {
    &:before {
      transform: none;
      left: 15px;
    }
  }
`;

export const TimelineLastItem = styled.li`
  position: relative;
  width: 100%;
  max-width: 970px;
  margin: 0 auto;
  padding-top: 135px;
  clear: both;
  z-index: 5;
  &:before,
  &:after {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    z-index: 7;
  }
  &:before {
    left: 0;
    width: 375px;
    height: 121px;
    background: url(${cloud01}) center no-repeat;
    background-size: contain;
    margin-top: 53px;
    margin-left: -60px;
  }
  &:after {
    right: 0;
    width: 389px;
    height: 84px;
    background: url(${cloud02}) center no-repeat;
    background-size: contain;
    margin-top: 150px;
    margin-right: -85px;
  }
  header {
    position: relative;
    width: 100%;
    border-radius: 50px 20px;
    background-color: #fff;
    box-shadow: 20px 7px 40px #00000047;
    padding: 0 35px 30px;
    h2 {
      width: 100%;
      color: #27357c;
      font-size: 30px;
      font-weight: 800;
      padding-bottom: 5px;
      text-align: center;
      padding-top: 170px;
      background: url(${likeIcon}) center top no-repeat;
      float: left;
      margin-top: -65px;
      margin-bottom: 10px;
      text-transform: uppercase;
    }
    p {
      font-size: 27px;
      line-height: 33px;
      padding-bottom: 3px;
      span {
        color: #831d13;
        font-weight: 700;
        display: block;
      }
      ul {
        list-style: disc;
        padding: 20px 0;
        padding-left: 30px;
        li {
          padding-bottom: 10px;
        }
      }
      a {
        color: #1d4192;
        font-weight: 700;
      }
    }
  }
  @media (max-width: 1200px) {
    header {
      h2 {
        font-size: calc(100vw / 40);
      }
      p {
        font-size: calc(100vw / 45);
      }
    }
  }
  @media (max-width: 1200px) {
    overflow-x: hidden;
    padding-bottom: 55px;
    padding-left: 15px;
    padding-right: 15px;
    max-width: none;
  }
  @media (max-width: 990px) {
    &:before {
      width: 35%;
      margin-left: -5%;
      margin-top: 15%;
    }
    &:after {
      width: 35%;
      margin-right: -5%;
      margin-top: 15%;
    }
  }
  @media (max-width: 768px) {
    header {
      h2 {
        font-size: 25px;
      }
      p {
        font-size: 18px;
      }
    }
  }
  @media (max-width: 500px) {
    &:before,
    &:after {
      display: none;
    }
  }
`;
